<template>
  <v-dialog v-model="visible" persistent width="80%" max-width="600px">
    <v-card class="tcdc-card-min-height tcdc-calendar-card">
      <div class="d-flex flex-column pa-8">
        <div class="d-flex flex-1 justify-space-between mb-5">
<!--          <img-->
<!--            :src="image"-->
<!--            class="tcdc-calendar-card-icon-noti calendar-card-image-highlight"-->
<!--          />-->
          <v-img v-if="image" :src="image" max-width="50%" />
          <v-spacer></v-spacer>
          <v-btn icon @click="onClose">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </div>
<!--        <div class="d-flex align-center justify-space-between mb-5">-->
<!--          <span-->
<!--            class="sub-header2 bold white&#45;&#45;text"-->
<!--          >{{description}}</span>-->
<!--        </div>-->
        <div class="d-flex flex-1 py-3 mb-8">
          <span class="header bold white--text">{{name}}</span>
        </div>
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-end">
            <img
              src="../../assets/icons/marker.png"
              class="tcdc-calendar-card-icon-marker mr-2 calendar-card-image-highlight"
            />
            <span class="bold white--text">{{ location }}</span>
          </div>
          <div class="d-flex align-end" v-if="routing">
            <span class="bold white--text cursor-pointer" @click="routeTo(routing)">{{$t('designCalendar.readmore')}}</span>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    location: {
      type: String,
      default: ''
    },
    routing: {
      type: Number,
      default: null
    }
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    routeTo(url) {
      if (url) {
          this.$router.push({ name: "DesignCalendarDetail", params: { id: url } })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-calendar-card {
  background-color: $tcdcGreen;
}
.tcdc-calendar-card-icon-marker {
  width: 15px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}
.tcdc-calendar-card-icon-noti {
  width: 30px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}
.tcdc-card-min-height {
  min-height: 250px;
}
</style>
